import {
    defaultIdAttribute,
    defaultMergeStrategy,
    defaultProcessStrategy,
} from '/b2b/common/helpers/Normalizr';

import { schema } from 'normalizr';

/**
 * @export
 * @typedef IabVendor
 * @property {number} id - The unique ID of the vendor.
 * @property {string} name - The name of the vendor.
 * @property {number[]} purposes - Array of purpose IDs that the vendor uses.
 * @property {number[]} legIntPurposes - Array of purpose IDs that the vendor relies on legitimate interest for.
 * @property {number[]} flexiblePurposes - Array of purpose IDs that the vendor has marked as flexible.
 * @property {number[]} specialPurposes - Array of purpose IDs that the vendor has marked as special.
 * @property {number[]} features - Array of feature IDs that the vendor uses.
 * @property {number[]} specialFeatures - Array of feature IDs that the vendor has marked as special.
 * @property {number} cookieMaxAgeSeconds - The maximum age of the vendor's cookies in seconds.
 * @property {boolean} usesCookies - Whether the vendor uses cookies.
 * @property {boolean} cookieRefresh - Whether the vendor refreshes cookies.
 * @property {Object[]} urls - Array of objects containing URLs related to the vendor, such as privacy policy and legitimate interest claim.
 * @property {string} urls[].langId - The language ID for the URLs (e.g., "en" for English).
 * @property {string} urls[].privacy - The URL to the vendor's privacy policy.
 * @property {string} urls[].legIntClaim - The URL to the vendor's legitimate interest claim (if applicable).
 * @property {boolean} usesNonCookieAccess - Whether the vendor uses non-cookie access methods (e.g., local storage, fingerprinting).
 * @property {Object} dataRetention - An object containing data retention information for the vendor.
 * @property {number} dataRetention.stdRetention - The standard data retention period in days.
 * @property {Object} dataRetention.purposes - An object mapping purpose IDs to specific data retention periods in days for those purposes.
 * @property {Object} dataRetention.specialPurposes - An object mapping special purpose IDs to specific data retention periods in days for those special purposes.
 * @property {number[]} dataDeclaration - Array of data declaration IDs that the vendor has made.
 * @property {string} deviceStorageDisclosureUrl - The URL to the vendor's device storage disclosure.
 */

export const entityName = 'iabVendor';
export const idAttribute = 'id';

export const mergeStrategy = defaultMergeStrategy(idAttribute);
export const processStrategy = defaultProcessStrategy(idAttribute);

export default new schema.Entity(entityName, undefined, {
    idAttribute: defaultIdAttribute(idAttribute),
    mergeStrategy,
    processStrategy,
});
